// different from PlanComponentCategory because they don't map to pages one-to-one /shrug
export var PlanComponentPageKey;
(function (PlanComponentPageKey) {
    PlanComponentPageKey["Scope1CutEnergyWaste"] = "scope1CutEnergyWaste";
    PlanComponentPageKey["Scope1Electrify"] = "scope1Electrify";
    PlanComponentPageKey["Scope1BuyClean"] = "scope1BuyClean";
    PlanComponentPageKey["Scope1LessCommonSolutions"] = "scope1LessCommonSolutions";
    PlanComponentPageKey["Scope2CutEnergyWaste"] = "scope2CutEnergyWaste";
    PlanComponentPageKey["Scope2BuyClean"] = "scope2BuyClean";
})(PlanComponentPageKey || (PlanComponentPageKey = {}));
